'use strict';

var React = require('react');

var SvgIdentityCardMajor = function SvgIdentityCardMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1.5 3a1.5 1.5 0 0 0-1.5 1.5v11a1.5 1.5 0 0 0 1.5 1.5h17a1.5 1.5 0 0 0 1.5-1.5v-11a1.5 1.5 0 0 0-1.5-1.5h-17zm10.1 3a.8.8 0 0 0 0 1.6h5.6a.8.8 0 0 0 0-1.6h-5.6zm0 3.2a.8.8 0 0 0 0 1.6h5.6a.8.8 0 0 0 0-1.6h-5.6zm0 3.2a.8.8 0 0 0 0 1.6h4a.8.8 0 0 0 0-1.6h-4zm-6.1-2.844c.966 0 1.75-.796 1.75-1.778s-.784-1.778-1.75-1.778-1.75.796-1.75 1.778.784 1.778 1.75 1.778zm-3.5 3.11c0 .738.588 1.334 1.313 1.334h4.374c.725 0 1.313-.597 1.313-1.333 0-.737-.656-2.223-3.5-2.223s-3.5 1.486-3.5 2.223z"
  }));
};

exports.SvgIdentityCardMajor = SvgIdentityCardMajor;
